import type { HuntAggressiveness } from '@/types';

export const AGGRESSIVENESS_OPTIONS: ReadonlyArray<{
  value: HuntAggressiveness;
  label: string;
  sublabel: string;
}> = [
  {
    value: 'cautious',
    label: 'Cautious',
    sublabel:
      'Narrow iterations. Confirms one vulnerability at a time and does not follow leads to related infrastructure.',
  },
  {
    value: 'balanced',
    label: 'Balanced',
    sublabel:
      'Default posture. Follows high-value leads and pivots to related infrastructure when the evidence warrants it.',
  },
  {
    value: 'aggressive',
    label: 'Aggressive',
    sublabel:
      'Deep multi-hop pivots and attack chaining. Records confirmed chains as attack graphs in the Attack Paths tab.',
  },
];

export interface HannibalLaunchConfig {
  mandate: string;
  finishCriteria: string;
  expiresAt: string;
  agent: string;
  // In-scope asset keys (e.g. #asset#example.com). Empty ⇒ all active
  // targets in Guard.
  scope: string[];
  // Pivoting posture: cautious | balanced (default) | aggressive.
  aggressiveness: HuntAggressiveness;
}
